{
  "travelExtras": {
    "heading": "Viimeinen hetki ostaa lisämukavuuksia",
    "removeAll": "Poista kaikki",
    "removeAllModal": {
      "title": "Poista kaikki maksamattomat lisäpalvelut",
      "text": "Kaikki jo maksetut lisäpalvelut säilyvät varauksessasi."
    },
    "unpaidItems": {
      "title": "Lisäpalvelut varataan sinulle 15 minuutiksi",
      "text": "Maksa tai poista ne saadaksesi tarkastuskorttisi."
    }
  },
  "meta": {
    "travelExtras": {
      "title": "Varaukseni - Osta lisäpalveluita"
    }
  },
  "checkIn": {
    "technicalStop": {
      "tag": "Tekninen välilasku",
      "routes": {
        "helMel": {
          "offboardingNotice": "Bangkokissa on tekninen välilasku. Sinun täytyy poistua koneesta ja siirtyä turvatarkastukseen välilaskun aikana.",
          "secondLegNotice": "Valmistaudu näyttämään Bangkok–Melbourne-tarkastuskorttisi turvatarkastuksessa teknisen välilaskun aikana Bangkokissa.",
          "viewInstructions": "Katso ohjeet",
          "instructions": {
            "title": "Välilaskun aikana Bangkokissa",
            "body": "<li>Sinun täytyy poistua koneesta</li><li>Ota mukaan kaikki käsimatkatavarasi</li><li>Seuraa opasteita vaihtomatkustajien turvatarkastukseen ja valmistaudu näyttämään tarkastuskorttisi (BKK–MEL)</li><li>Siirry suoraan lähtöportille</li><li>Valmistaudu käsimatkatavaroiden turvatarkastukseen</li><li>Älä tuo mukanasi lennolle yli 100 ml nestepakkauksia</li>",
            "linkText": "Lue lisää"
          }
        },
        "melHel": {
          "offboardingNotice": "Bangkokissa on tekninen välilasku. Sinun täytyy poistua koneesta ja siirtyä turvatarkastukseen välilaskun aikana.",
          "secondLegNotice": "Valmistaudu näyttämään Bangkok–Helsinki-tarkastuskorttisi turvatarkastuksessa teknisen välilaskun aikana Bangkokissa.",
          "viewInstructions": "Katso ohjeet",
          "instructions": {
            "title": "Välilaskun aikana Bangkokissa",
            "body": "<li>Sinun täytyy poistua koneesta</li><li>Ota mukaan kaikki käsimatkatavarasi</li><li>Seuraa opasteita vaihtomatkustajien turvatarkastukseen ja valmistaudu näyttämään tarkastuskorttisi (BKK–HEL)</li><li>Siirry suoraan lähtöportille</li>",
            "linkText": "Lue lisää"
          }
        }
      }
    }
  },
  "modifyYourTrip": {
    "changeOfPlans": {
      "notification": {
        "contactCustomerService": "Ota yhteyttä <a href=\"https://www.finnair.com/fi-fi/asiakaspalvelu-ja-yhteystiedot\" target=\"_blank\"><strong>asiakaspalveluumme</strong></a>, jotta voimme auttaa sinua muuttamaan lentosi."
      },
      "message": {
        "upgradedFlights": {
          "partial": "<strong>Koska olet tehnyt matkustusluokan korotuksen joillekin lennoillesi</strong>, muutokset on tehtävä virkailijan kautta, jotta matkustusluokkasi säilyy. Aloita keskustelu tekoälyavustaja Sisun kanssa ja saat yhteyden virkailijaan maksutta.",
          "plural": "<strong>Koska olet tehnyt matkustusluokan korotuksen lennoillesi</strong>, muutokset on tehtävä virkailijan kautta, jotta matkustusluokkasi säilyy. Aloita keskustelu tekoälyavustaja Sisun kanssa ja saat yhteyden virkailijaan maksutta.",
          "singular": "<strong>Koska olet tehnyt matkustusluokan korotuksen lennollesi</strong>, muutokset on tehtävä virkailijan kautta, jotta matkustusluokkasi säilyy. Aloita keskustelu tekoälyavustaja Sisun kanssa ja saat yhteyden virkailijaan maksutta."
        }
      }
    }
  }
}
